/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/redo'
export default icon
